/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-duplicates */
import Head from 'next/head';
import React, { useState } from 'react';

import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { IEvent, IMapRender } from '@/@types/events';
import { ReactComponent as IconCalendarEventSvg } from '@/assets/icon-calendar-event.svg';
import { ReactComponent as IconFacebookSvg } from '@/assets/icon-facebook.svg';
import { ReactComponent as IconMarkerMapsSvg } from '@/assets/icon-marker-maps.svg';
import { ReactComponent as IconTwitterSvg } from '@/assets/icon-twitter.svg';
import { ReactComponent as IconWhatsappSvg } from '@/assets/icon-whatsapp.svg';
import EventTickets from '@/components/Widget';
import { makeCdnLink, showAlert } from '@/utils';
import {
  BookableObjectProps,
  SeatingChart,
  SeatsioSeatingChart,
  SelectableObjectProps,
} from '@seatsio/seatsio-react';

import * as S from './styles';

export type TemplateEventByIdProps = {
  rowEvent: IEvent;
  token?: string;
  mapRender?: IMapRender | null;
};

const TemplateEventById = ({
  rowEvent,
  token,
  mapRender,
}: TemplateEventByIdProps) => {
  const [termChecked, setTermChecked] = useState(false);
  const [selectedMapSeats, setSelectedMapSeats] = useState<
    { codItem: number; objectId: string }[]
  >([]);
  const [seatingChart, setSeatingChart] = useState<SeatingChart>();

  const handleSelectSeat = (object: SelectableObjectProps) => {
    const codItem = rowEvent.seats.find(
      value => value.LABEL === object.label,
    )?.codItem;

    if (codItem) {
      setSelectedMapSeats(state => [
        ...state,
        { codItem, objectId: object.label },
      ]);

      const obj: any = object;
      const { holdToken } = obj.chart;

      if (typeof window === 'object') {
        window.localStorage.setItem('@bcart.holdToken', holdToken);
      }

      showAlert(`${object.label} adicionado ao carrinho`, 'default');
      return;
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (object.deselect) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      object.deselect();
    }
    showAlert(`Lugar sem item vinculado.`, 'error');
  };

  const handleDeselectSeat = (object: BookableObjectProps) => {
    const codItem = rowEvent.seats.find(
      value => value.LABEL === object.label,
    )?.codItem;
    if (codItem) {
      setSelectedMapSeats(state =>
        state.filter(value => value.codItem !== codItem),
      );
    }
  };

  return (
    <>
      {[68, 70, 71].includes(rowEvent.codEvento) && (
        <Head>
          {/* SMART PIXEL */}
          {/* Xandr Universal Pixel - Initialization (include only once per page) */}
          <script
            dangerouslySetInnerHTML={{
              __html: `!function(e,i){if(!e.pixie){var n=e.pixie=function(e,i,a){n.actionQueue.push({action:e,actionValue:i,params:a})};n.actionQueue=[];var a=i.createElement("script");a.async=!0,a.src="//acdn.adnxs.com/dmp/up/pixie.js";var t=i.getElementsByTagName("head")[0];t.insertBefore(a,t.firstChild)}}(window,document);
        pixie('init', '00c990ed-b282-48c0-ad6e-61c768b36751');`,
            }}
          />

          {/* Xandr Universal Pixel - PageView Event */}
          <script
            dangerouslySetInnerHTML={{
              __html: `pixie('event', 'PageView');`,
            }}
          />

          <noscript
            dangerouslySetInnerHTML={{
              __html: `<img
            src="https://ib.adnxs.com/pixie?pi=00c990ed-b282-48c0-ad6e-61c768b36751&e=PageView&script=0"
            width="1"
            height="1"
            style="display:none"
          />`,
            }}
          />

          {/* LP Lotame */}
          <script src="https://bcp.crwdcntrl.net/5/c=11255/b=94654194" />

          {/* PIXEL FACEBOOK */}
          <script
            dangerouslySetInnerHTML={{
              __html: `!function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '608357607167295');
            fbq('track', 'PageView');`,
            }}
          />

          <noscript
            dangerouslySetInnerHTML={{
              __html: `<img height="1" width="1" style="display:none"
              src="https://www.facebook.com/tr?id=608357607167295&ev=PageView&noscript=1"
              />`,
            }}
          />
        </Head>
      )}
      {[122].includes(rowEvent.codEvento) && (
        <Head>
          {/* PIXEL FACEBOOK */}
          <script
            dangerouslySetInnerHTML={{
              __html: `!function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '626308251684861');
            fbq('track', 'PageView');`,
            }}
          />

          <noscript
            dangerouslySetInnerHTML={{
              __html: `<img height="1" width="1" style="display:none"
              src="https://www.facebook.com/tr?id=626308251684861&ev=PageView&noscript=1"
              />`,
            }}
          />
        </Head>
      )}
      <S.Container>
        {rowEvent.imagemEvento && (
          <S.EventCover>
            <figure>
              <img
                src={makeCdnLink(rowEvent.imagemEvento)}
                alt={rowEvent.nomeEvento}
                loading="lazy"
              />
            </figure>

            <figcaption>
              compartilhar:
              <a
                href={`https://www.facebook.com/sharer.php?u=${
                  typeof window !== 'undefined' ? window.location.href : ''
                }`}
                target="_blank"
                rel="noreferrer"
                className="figcaption-facebook-svg"
              >
                <IconFacebookSvg />
              </a>
              <a
                href="whatsapp://send"
                data-action="share/whatsapp/share"
                target="_blank"
                rel="noreferrer"
                className="figcaption-whatsapp-svg"
              >
                <IconWhatsappSvg />
              </a>
              <a
                href={`https://twitter.com/intent/tweet?url=${
                  typeof window !== 'undefined' ? window.location.href : ''
                }`}
                target="_blank"
                rel="noreferrer"
                className="figcaption-twitter-svg"
              >
                <IconTwitterSvg />
              </a>
            </figcaption>
          </S.EventCover>
        )}

        <S.Wrapper>
          <S.EventWrapper>
            <S.EventHeader>
              <S.EventTitle>{rowEvent.nomeEvento}</S.EventTitle>

              <S.EventDate>
                <IconCalendarEventSvg />
                <p>
                  {format(
                    new Date(rowEvent.dataIniEvento.replace(/-/g, '/')),
                    "dd 'de' MMMM 'de' yyyy ' - ' HH'h'mm",
                    {
                      locale: ptBR,
                    },
                  )}
                </p>
              </S.EventDate>

              <S.EventLocation>
                <IconMarkerMapsSvg />
                <p>{rowEvent.localEvento.normalize()}</p>
              </S.EventLocation>
            </S.EventHeader>

            <S.Organizer>
              {/* Organizador: <strong>Placeholder Produções</strong> */}
            </S.Organizer>

            {mapRender && (
              <S.SeatsioContainer>
                <SeatsioSeatingChart
                  workspaceKey={mapRender.data.workspaceKey}
                  event={mapRender.data.eventId}
                  region="sa"
                  language="pt"
                  session="continue"
                  onObjectSelected={handleSelectSeat}
                  onObjectDeselected={handleDeselectSeat}
                  onChartRendered={chart => {
                    setSeatingChart(chart);
                    const selectedMapSeats = chart.selectedObjects
                      .map<{
                        codItem: number;
                        objectId: string;
                      }>(object => ({
                        codItem: rowEvent.seats.find(
                          value => value.LABEL === object,
                        )?.codItem,
                        objectId: object,
                      }))
                      .filter(value => !!value);
                    setSelectedMapSeats(selectedMapSeats);
                  }}
                  showFullScreenButton={false}
                />
              </S.SeatsioContainer>
            )}

            <S.EventBody
              dangerouslySetInnerHTML={{
                __html: rowEvent.descEvento.normalize(),
              }}
            />

            <S.Terms>
              <input
                type="checkbox"
                id="term"
                checked={termChecked}
                onChange={() => setTermChecked(!termChecked)}
              />

              <label htmlFor="term">
                Li e aceito os{' '}
                <a
                  href="https://vendas.boratickets.com.br/legal/termos-uso"
                  target="_blank"
                  rel="noreferrer"
                >
                  Termos de uso
                </a>{' '}
                ,{' '}
                <a
                  href="https://vendas.boratickets.com.br/legal/politica-privacidade"
                  target="_blank"
                  rel="noreferrer"
                >
                  privacidade
                </a>{' '}
                e{' '}
                <a
                  href="https://vendas.boratickets.com.br/legal/politica-compras"
                  target="_blank"
                  rel="noreferrer"
                >
                  política de compra
                </a>
                .
              </label>
            </S.Terms>
          </S.EventWrapper>

          <EventTickets
            eventId={rowEvent.codEvento}
            eventHaveSeats={rowEvent.seats.length > 0}
            termChecked={termChecked}
            token={token}
            selectedMapSeats={selectedMapSeats}
            seatingChart={seatingChart}
          />
        </S.Wrapper>
      </S.Container>
      <S.FooterEventContainer>
        <S.FooterEventLocal>
          <div>
            <h3>LOCAL</h3>
            <h4>
              <strong>{rowEvent.localEvento.split(',')[0].normalize()}</strong>
            </h4>
            <p>{rowEvent.localEvento.split(',')[1].normalize()}</p>
            <p>{rowEvent.localEvento.split(',')[2].normalize()}</p>
          </div>

          {/* <div>
            <button type="button">
              <IconMarkerMapsSvg />
              Ver mapa
            </button>
          </div> */}
        </S.FooterEventLocal>

        <S.HelpCentral>
          <p>
            Tem alguma dúvida? fale conosco através do e-mail{' '}
            <strong>contato@boratickets.com.br</strong>
          </p>
          {/* <a href="/">CENTRAL DE AJUDA</a> */}
        </S.HelpCentral>
      </S.FooterEventContainer>
    </>
  );
};

export default React.memo(TemplateEventById);
